import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { Segment } from '@fxtr/i18n';

const { Option } = Select;

const segments = [
  { key: 'all', label: 'All Countries' },
  { key: Segment.Fixter_UK, label: 'United Kingdom 🇬🇧' },
  { key: Segment.Fixter_FR, label: 'France 🇫🇷' },
];

const renderSegmentOptions = () =>
  segments.map((segment) => (
    <Option key={segment.key} value={segment.key}>
      {segment.label}
    </Option>
  ));

export default function SegmentFilter({ onChange, value, style }) {
  return (
    <div className={`filter-container ${value ? 'active' : ''}`} style={style}>
      <img src="/assets/icons/filters/globe.svg" alt="Country filter" />
      <Select
        onChange={onChange}
        value={value || 'all'}
        style={{ width: '90%' }}
        dropdownMatchSelectWidth={false}
      >
        {renderSegmentOptions()}
      </Select>
    </div>
  );
}

SegmentFilter.propTypes = {
  onChange: PropTypes.any.isRequired,
  value: PropTypes.string,
  style: PropTypes.object,
};

SegmentFilter.defaultProps = {
  value: null,
  style: null,
};
